export const CourseListData = [
    {
      no: 1,
      name: "Kyaw Thiha Soe",
      // description:'သင့် iPad Air ကို Laptop ဖြစ်သွားစေမယ့်  Logitech Folio Touch Keyboard Case with Trackpad for iPad Air      iPad Air သုံးတဲ့သူတွေအတွက် Trackpad ပါဝင်တဲ့ Keyboard Case ကောင်းကောင်းရှာနေတယ်ဆိုရင် Logitech Brand ကနေ ထုတ်ပေးထားတဲ့ Folio Touch Keyboard Case with Trackpad ကို iSure မှာ ဝယ်ယူနိုင်ပြီဖြစ်ပါတယ်။ Full-size Backlit Keyboard အမျိုးအစားဖြစ်တာကြောင့် တကယ့် Laptop တစ်လုံးရဲ့ Layout အတိုင်း ကောင်းမွန်စွာ စာရိုက်နိုင်မှာဖြစ်သလို Backlit ဖြစ်တာကြောင့် အမှောင်ထဲမှာလည်း သုံးနိုင်မှာဖြစ်ပါတယ်။ Trackpad ကိုလည်း Precision Trackpad အမျိုးအစားကို သုံးပေးထားတဲ့အတွက် တိကျနေမှာဖြစ်သလို Gesture တွေကိုလည်း ထောက်ပံ့ပေးနိုင်မှာပါ။ Keyboard မှာဆိုရင် iPadOS အတွက် Home Screen ၊ Siri ၊ Search ၊ Media Controls စတာတွေကို ထိန်းချူပ်နိုင်တဲ့ Shortcut Keys တွေလည်းပါဝင်မှာဖြစ်ပါတယ်။အကောင်းဆုံးအချက်ကတော့ iPad Air ကို နောက်ကျောဘက်မှာ ထောင်ပေးထားနိုင်ဖို့အတွက် 40-degree Tilt Kick-back Stand ပါဝင်တာပဲဖြစ်ပါတယ်။ Keyboard ကို အသုံးမပြုတဲ့အချိန်မှာလည်း ဖြုတ်ထားနိုင်ပြီး Kick-back Stand ကို ရုပ်ရှင်ကြည့်ဖို့ သုံးနိုင်ဦးမှာပါ။ ပုံစံ (၄) မျိုးအထိ ပြောင်းလဲအသုံးပြုနိုင်တာကြောင့် ပုံဆွဲ၊ စာဖတ်ချင်တဲ့သူတွေအတွက်လည်း အဆင်ပြေမှာဖြစ်ပါတယ်။ ချိတ်ဆက်ဖို့ကလည်း Smart Connector ကို အသုံးပြုပြီး ချိတ်ဆက်မှာဖြစ်တာကြောင့် Keyboard အတွက် သီးသန့်ပါဝါပေးစရာ၊ အားသွင်းဖို့လည်း မလိုအပ်ပါဘူး။ ',
      description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. In est numquam explicabo sit quam adipisci eos deserunt nihil nam pariatur itaque veniam vitae dolores sed, voluptates eius officia laborum recusandae?",
      url: "https://pedagoo.com/wp-content/uploads/2020/06/2250x1500_czy-warto-korzystac-ze-szkolen-online-ollh.jpg",
      category: "bbbbbb",
      createdAt: "2022-05-22",
      updatedAt: "2022-05-22",
    },
    {
      no: 2,
      name: "Kyaw Thiha Soe",
      description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. In est numquam explicabo sit quam adipisci eos deserunt nihil nam pariatur itaque veniam vitae dolores sed, voluptates eius officia laborum recusandae?",
      url: "https://pedagoo.com/wp-content/uploads/2020/06/2250x1500_czy-warto-korzystac-ze-szkolen-online-ollh.jpg",
      category: "2022",
      createdAt: "2022-05-22",
      updatedAt: "2022-05-22",
    },
    {
      no: 3,
      name: "Kyaw Thiha Soe",
      description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. In est numquam explicabo sit quam adipisci eos deserunt nihil nam pariatur itaque veniam vitae dolores sed, voluptates eius officia laborum recusandae?",
      url: "https://pedagoo.com/wp-content/uploads/2020/06/2250x1500_czy-warto-korzystac-ze-szkolen-online-ollh.jpg",
      category: "2022",
      createdAt: "2022-05-22",
      updatedAt: "2022-05-22",
    },
    {
      no: 4,
      name: "Kyaw Thiha Soe",
      description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. In est numquam explicabo sit quam adipisci eos deserunt nihil nam pariatur itaque veniam vitae dolores sed, voluptates eius officia laborum recusandae?",
      url: "https://pedagoo.com/wp-content/uploads/2020/06/2250x1500_czy-warto-korzystac-ze-szkolen-online-ollh.jpg",
      category: "2022",
      createdAt: "2022-05-22",
      updatedAt: "2022-05-22",
    },
    {
      no: 5,
      name: "Kyaw Thiha Soe",
      description: "sk6822386@gmail.com",
      image: "admin",description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. In est numquam explicabo sit quam adipisci eos deserunt nihil nam pariatur itaque veniam vitae dolores sed, voluptates eius officia laborum recusandae?",
      url: "https://pedagoo.com/wp-content/uploads/2020/06/2250x1500_czy-warto-korzystac-ze-szkolen-online-ollh.jpg",
      category: "2022",
      createdAt: "2022-05-22",
      updatedAt: "2022-05-22",
    },
    {
      no: 6,
      name: "Kyaw Thiha Soe",
      description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. In est numquam explicabo sit quam adipisci eos deserunt nihil nam pariatur itaque veniam vitae dolores sed, voluptates eius officia laborum recusandae?",
      url: "https://pedagoo.com/wp-content/uploads/2020/06/2250x1500_czy-warto-korzystac-ze-szkolen-online-ollh.jpg",
      category: "2022",
      createdAt: "2022-05-22",
      updatedAt: "2022-05-22",
    },
    {
      no: 7,
      name: "Kyaw Thiha Soe",
      description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. In est numquam explicabo sit quam adipisci eos deserunt nihil nam pariatur itaque veniam vitae dolores sed, voluptates eius officia laborum recusandae?",
      url: "https://pedagoo.com/wp-content/uploads/2020/06/2250x1500_czy-warto-korzystac-ze-szkolen-online-ollh.jpg",
      category: "2022",
      createdAt: "2022-05-22",
      updatedAt: "2022-05-22",
    },
    {
      no: 8,
      name: "Kyaw Thiha Soe",
      description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. In est numquam explicabo sit quam adipisci eos deserunt nihil nam pariatur itaque veniam vitae dolores sed, voluptates eius officia laborum recusandae?",
      url: "https://pedagoo.com/wp-content/uploads/2020/06/2250x1500_czy-warto-korzystac-ze-szkolen-online-ollh.jpg",
      category: "2022",
      createdAt: "2022-05-22",
      updatedAt: "2022-05-22",
    },
    {
      no: 9,
      name: "Kyaw Thiha Soe",
      description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. In est numquam explicabo sit quam adipisci eos deserunt nihil nam pariatur itaque veniam vitae dolores sed, voluptates eius officia laborum recusandae?",
      url: "https://pedagoo.com/wp-content/uploads/2020/06/2250x1500_czy-warto-korzystac-ze-szkolen-online-ollh.jpg",
      category: "2022",
      createdAt: "2022-05-22",
      updatedAt: "2022-05-22",
    },
    {
      no: 10,
      name: "Kyaw Thiha Soe",
      description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. In est numquam explicabo sit quam adipisci eos deserunt nihil nam pariatur itaque veniam vitae dolores sed, voluptates eius officia laborum recusandae?",
      url: "https://pedagoo.com/wp-content/uploads/2020/06/2250x1500_czy-warto-korzystac-ze-szkolen-online-ollh.jpg",
      category: "2022",
      createdAt: "2022-05-22",
      updatedAt: "2022-05-22",
    },
    {
      no: 11,
      name: "Kyaw Thiha Soe",
      description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. In est numquam explicabo sit quam adipisci eos deserunt nihil nam pariatur itaque veniam vitae dolores sed, voluptates eius officia laborum recusandae?",
      url: "https://pedagoo.com/wp-content/uploads/2020/06/2250x1500_czy-warto-korzystac-ze-szkolen-online-ollh.jpg",
      category: "2022",
      createdAt: "2022-05-22",
      updatedAt: "2022-05-22",
    },
    {
      no: 12,
      name: "Kyaw Thiha Soe",
      description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. In est numquam explicabo sit quam adipisci eos deserunt nihil nam pariatur itaque veniam vitae dolores sed, voluptates eius officia laborum recusandae?",
      url: "https://pedagoo.com/wp-content/uploads/2020/06/2250x1500_czy-warto-korzystac-ze-szkolen-online-ollh.jpg",
      category: "2022",
      createdAt: "2022-05-22",
      updatedAt: "2022-05-22",
    },
    {
      no: 13,
      name: "Kyaw Thiha Soe",
      description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. In est numquam explicabo sit quam adipisci eos deserunt nihil nam pariatur itaque veniam vitae dolores sed, voluptates eius officia laborum recusandae?",
      url: "https://pedagoo.com/wp-content/uploads/2020/06/2250x1500_czy-warto-korzystac-ze-szkolen-online-ollh.jpg",
      category: "2022",
      createdAt: "2022-05-22",
      updatedAt: "2022-05-22",
    },
    {
      no: 14,
      name: "Kyaw Thiha Soe",
      description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. In est numquam explicabo sit quam adipisci eos deserunt nihil nam pariatur itaque veniam vitae dolores sed, voluptates eius officia laborum recusandae?",
      url: "https://pedagoo.com/wp-content/uploads/2020/06/2250x1500_czy-warto-korzystac-ze-szkolen-online-ollh.jpg",
      category: "2022",
      createdAt: "2022-05-22",
      updatedAt: "2022-05-22",
    },
    {
      no: 15,
      name: "Kyaw Thiha Soe",
      description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. In est numquam explicabo sit quam adipisci eos deserunt nihil nam pariatur itaque veniam vitae dolores sed, voluptates eius officia laborum recusandae?",
      url: "https://pedagoo.com/wp-content/uploads/2020/06/2250x1500_czy-warto-korzystac-ze-szkolen-online-ollh.jpg",
      category: "2022",
      createdAt: "2022-05-22",
      updatedAt: "2022-05-22",
    },
    {
      no: 16,
      name: "Kyaw Thiha Soe",
      description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. In est numquam explicabo sit quam adipisci eos deserunt nihil nam pariatur itaque veniam vitae dolores sed, voluptates eius officia laborum recusandae?",
      url: "https://pedagoo.com/wp-content/uploads/2020/06/2250x1500_czy-warto-korzystac-ze-szkolen-online-ollh.jpg",
      category: "2022",
      createdAt: "2022-05-22",
      updatedAt: "2022-05-22",
    },
    {
      no: 17,
      name: "Kyaw Thiha Soe",
      description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. In est numquam explicabo sit quam adipisci eos deserunt nihil nam pariatur itaque veniam vitae dolores sed, voluptates eius officia laborum recusandae?",
      url: "https://pedagoo.com/wp-content/uploads/2020/06/2250x1500_czy-warto-korzystac-ze-szkolen-online-ollh.jpg",
      category: "2022",
      createdAt: "2022-05-22",
      updatedAt: "2022-05-22",
    },
    {
      no: 18,
      name: "Kyaw Thiha Soe",
      description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. In est numquam explicabo sit quam adipisci eos deserunt nihil nam pariatur itaque veniam vitae dolores sed, voluptates eius officia laborum recusandae?",
      url: "https://pedagoo.com/wp-content/uploads/2020/06/2250x1500_czy-warto-korzystac-ze-szkolen-online-ollh.jpg",
      category: "2022",
      createdAt: "2022-05-22",
      updatedAt: "2022-05-22",
    },
    {
      no: 19,
      name: "Kyaw Thiha Soe",
      description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. In est numquam explicabo sit quam adipisci eos deserunt nihil nam pariatur itaque veniam vitae dolores sed, voluptates eius officia laborum recusandae?",
      url: "https://pedagoo.com/wp-content/uploads/2020/06/2250x1500_czy-warto-korzystac-ze-szkolen-online-ollh.jpg",
      category: "2022",
      createdAt: "2022-05-22",
      updatedAt: "2022-05-22",
    },
    {
      no: 20,
      name: "Kyaw Thiha Soe",
      description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. In est numquam explicabo sit quam adipisci eos deserunt nihil nam pariatur itaque veniam vitae dolores sed, voluptates eius officia laborum recusandae?",
      url: "https://pedagoo.com/wp-content/uploads/2020/06/2250x1500_czy-warto-korzystac-ze-szkolen-online-ollh.jpg",
      category: "2022",
      createdAt: "2022-05-22",
      updatedAt: "2022-05-22",
    },
    
  ];
  